var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-2" },
    [
      _c("div", { staticClass: "d-flex flex-row mb-2" }, [
        _c("div", { staticClass: "btn-group ml-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              on: {
                click: function($event) {
                  return _vm.store.reload(true)
                }
              }
            },
            [_c("i", { staticClass: "fa fa-sync" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              on: { click: _vm.newCollection }
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.store.collections,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "emptystate",
            fn: function() {
              return [
                _c("CenterOnParent", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("txtSearchNoRows")) +
                      "\n      "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-success",
                          attrs: {
                            href: _vm.getUrl(props.row),
                            target: "_blank"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-external-link-alt" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.printQrCollection(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-qrcode" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.editCollection(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-pen" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.deleteCollection(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("CollectionDeleteModal", { ref: "deleteModal" }),
      _vm._v(" "),
      _c("CollectionEditModal", { ref: "editModal" }),
      _vm._v(" "),
      _c("CollectionPrintModal", { ref: "printModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }